import React from 'react'
import styled from '@emotion/styled'
import { Button, ChevronLeftIcon, ChevronRightIcon, TrashIcon } from '@labsavvyapp/components'

const TestSelectionControlsContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  align-content: center;
  justify-content: center;
  height: 100%;
  gap: 8px;

  svg {
    width: 14px;
    height: 14px;
  }
`

interface OrdersetCategoryTestSelectionControlsProps {
  isSelectButtonDisabled: boolean
  handleTestSelection: () => void
  isUnselectTestButtonDisabled: boolean
  handleTestUnselection: () => void
}

export const OrdersetCategoryTestSelectionControls = (props: OrdersetCategoryTestSelectionControlsProps) => {
  const { isSelectButtonDisabled, handleTestSelection, isUnselectTestButtonDisabled, handleTestUnselection } = props
  return (
    <TestSelectionControlsContainer>
      <Button radius="md" size="xs" uppercase variant="filled" onClick={handleTestSelection} disabled={isSelectButtonDisabled}>
        <ChevronRightIcon />
      </Button>
      <Button radius="md" size="xs" uppercase variant="filled" onClick={handleTestUnselection} disabled={isUnselectTestButtonDisabled} color="red">
        <TrashIcon />
      </Button>
    </TestSelectionControlsContainer>
  )
}
